import { message } from 'antd';
import Axios from 'axios';
import moment from 'moment';
import { chooseEnvironment } from './baseuri';
import { getEmailToken } from './utils/auth';
import { getDeviceDetails, getLocation } from './utils/request-helpers';

const emailBaseUrl = Axios.create({
	baseURL: chooseEnvironment().robot,
	headers: {
		...getLocation(),
		...getDeviceDetails(),
		authentication: `Bearer ${localStorage.getItem('emailToken')}`,
		authorization: String(chooseEnvironment().auth),
		timestamp: moment().valueOf(),
	},
});

/**
 * Intercept the axios requests and add the necessary header properties
 * that the backend expects
 */

emailBaseUrl.interceptors.request.use((request) => {
	const timestamp = moment().valueOf().toString();
	if (request.headers) {
		// request.headers.apisignature = getApiSignature(request, timestamp);
		request.headers.timestamp = timestamp;
		request.headers.authentication = `Bearer ${localStorage.getItem(
			'emailToken'
		)}`;
		return request;
	}
	throw new Error('no headers object');
});

/**
 * Handle lack of authentication
 * */
// emailBaseUrl.interceptors.response.use(
// 	(res) => res,
// 	async (error) => {
// 		const { status } = error.response;
// 		const token = localStorage.getItem('emailToken');

// 		if (!token || status === 401) {
// 			const originalRequest = error.config;
// 			originalRequest._retry = true;
// 			await getEmailToken();
// 			return emailBaseUrl(originalRequest);
// 		}

// 		message.warn('You dont have the permission to access this page');

// 		throw error;
// 	}
// );
emailBaseUrl.interceptors.response.use(
	(res) => res,
	async (error) => {
		const { status } = error.response || {};
		const originalRequest = error.config;

		if (!originalRequest._retryCount) {
			originalRequest._retryCount = 0;
		}

		if (status === 429 && originalRequest._retryCount < 3) {
			// Limit to 3 retries
			const retryAfter =
				error.response.headers['retry-after'] ||
				Math.pow(2, originalRequest._retryCount) * 1000; // Exponential backoff
			originalRequest._retryCount += 1;
			console.warn(
				`Rate limit exceeded. Retrying after ${retryAfter / 1000} seconds.`
			);
			await new Promise((resolve) => setTimeout(resolve, retryAfter));
			return emailBaseUrl(originalRequest);
		}

		if (!localStorage.getItem('emailToken') || status === 401) {
			if (!originalRequest._retry) {
				originalRequest._retry = true;
				try {
					await getEmailToken();
					originalRequest.headers.authentication = `Bearer ${localStorage.getItem(
						'emailToken'
					)}`;
					return emailBaseUrl(originalRequest);
				} catch (tokenError) {
					message.error('Failed to refresh token');
					throw tokenError;
				}
			}
		}

		message.warn(
			'You don’t have permission to access this page or rate limit exceeded'
		);
		throw error;
	}
);

export default emailBaseUrl;
